<template>
    <div class="b_typical_modal b_modal_info" v-if="smallAlert">
        <div class="b_modal_darker"></div>
        <div class="b_modal_inner">
            <div class="e_modal_xcross" @click.prevent="dialogHide()"></div>
            <div class="e_modal_titl">
                ПРЕДУПРЕЖДЕНИЕ
            </div>
            <div class="e_modal_fulltext">
                {{ message }}
                <div class="m_gap_smd"></div>

                <a href="#" class="typical_button m_pink m_modal_action" @click.prevent="dialogHide()">
                    <span class="typical_button_inner">Закрыть</span>
                    <span class="typical_button_angle"><span class="typical_button_angle_right"></span></span>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
  export default {
    components: {
    },
    data() {
      return {
        smallAlert: false,
        message: ''
      }
    },
    methods: {
      dialogHide () {
        this.smallAlert = false
      },
      warningShow (msg) {
        this.message = msg
        this.smallAlert = true
      }
    }
  }
</script>

<style lang="scss">
</style>
